module.exports = __webpack_public_path__ + "img/上下滑動.b11e92c2.svg";